/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * App config: admin Users.
 */

const DEFAULT_ADMIN_EMAILS = [
    'andyc@farelanes.com',
    'andrew@farelanes.com',
    'andrew.cohen@farelanes.com',
    'neal.huffman@farelanes.com',
    'kapil.reddy@farelanes.com',
];

/** Comma-separated list in REACT_APP_ADMIN_EMAILS overrides defaults. */
export function getAdminUsers() {
    const fromEnv = process.env.REACT_APP_ADMIN_EMAILS;
    if (fromEnv) {
        return fromEnv.split(',').map((email) => email.trim()).filter(Boolean);
    }
    return DEFAULT_ADMIN_EMAILS;
}
